{
    "AddCRMTitle": "Add CRM Integration",
    "ModifyCRMTitle": "Modify CRM Integration",
    "CRMDetailsTitle": "Details",
    "CRMScopeTitle": "Scope",
    "CRMConfigurationTitle": "Configuration",
    "CRMGeneralIDLabel": "ID",
    "CRMDetailsIDLabelPlaceholder": "[Auto Assigned]",
    "CRMDetailsDescriptionLabel": "Description",
    "CRMValidationDescriptionLabel": "Description is required",
    "CRMConfigurationCRMTypeLabel": "CRM",
    "CRMConfigurationTypeNone": "None",
    "CRMConfigurationTab_Setting_Name": "Setting Name",
    "CRMConfigurationTab_Value": "Value",
    "CRMConfigurationTemplateTypeLabel": "Type",
    "CRMConfigurationTab_TemplateType_Desktop": "Desktop",
    "CRMConfigurationTab_TemplateType_Cloud": "Cloud",
    "NAME": "CRMModal"
}
